import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Icon, Divider, Button, Table, Modal, Input, Select, message, Tag, Checkbox, Spin } from 'antd'
import { getCookie } from '../../../hook';
import './style.css';

import { 
    invite_candidate, 
    get_company, 
    get_department, 
    get_candidate, 
    set_candidate_convert,
    checklist_request,
    update_checklist_value } from './actions/onboard.action';

const Option = Select.Option;
class OnBoarding extends Component {
    constructor( props ){
        super( props );
        
        this.state = {
            data: [],
            visible: false,
            company_list: [],
            department_list: [],
            full_name: '',
            email: '',
            company: '',
            departments: '[]',
            department: '',
            current_user_type: '',
            department_id: 0,
            loading: false
        }

        this.handleDepartment = this.handleDepartment.bind( this );
        this.handleCancel = this.handleCancel.bind( this );
        this.handleOk = this.handleOk.bind( this );
        this.getColumnSearchProps = this.getColumnSearchProps.bind( this );
        this.handleChecked = this.handleChecked.bind( this );

    }

    handleChecked( checklist_id, e ){

        let value = 0;
        if( e.target.checked === true ){
            value = 1;
        }

        this.props.update_checklist_value( checklist_id, value );
        this.setState({ loading: true });

    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                }
        }
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    componentWillMount(){

        let user_id = "all";

        if( this.props.match.params.id ){
            user_id = this.props.match.params.id
        }

        let user = getCookie('dv_hrms_user').split(',');

        this.props.get_company();
        this.props.get_department();
        this.props.get_candidate( user_id );

        this.setState({
            current_user_type: user[3],
            department_id: user[7]
        });

    }

    componentWillReceiveProps( nextProps ){
        
        if( nextProps.onboard.length !== 0 ){
            if( nextProps.onboard.STATUS.CODE === "200" &&
                nextProps.onboard.STATUS.MESSAGE === "Successfully Listed Company" ) {
                this.setState({
                    company_list: nextProps.onboard.OUTPUT.DATA
                })
            }

            if( nextProps.onboard.STATUS.CODE === "200" &&
                nextProps.onboard.STATUS.MESSAGE === "Successfully Listed Department" ) {
                this.setState({
                    department_list: nextProps.onboard.OUTPUT.DATA
                })
            }

            if( nextProps.onboard.STATUS.CODE === "200" &&
                nextProps.onboard.STATUS.MESSAGE === "Successfully Listed Candidates" ) {
                this.setState({
                    data: nextProps.onboard.OUTPUT.DATA,
                });
            }

            if( nextProps.onboard.STATUS.CODE === "200" &&
                nextProps.onboard.STATUS.MESSAGE === "Successfully Candidate Converted" ) {

                message.success( 'Successfully Updated!' );
                let user_id = nextProps.onboard.OUTPUT.DATA;
                let self = this;

                setTimeout(() =>{
                    self.props.history.push( '/organization/employees/' + user_id );
                }, 500 );

            }

            if( nextProps.onboard.STATUS.CODE === "200" &&
                nextProps.onboard.STATUS.MESSAGE === "Successfully Updated" ){
                message.success( "Successfully Updated!" );
                this.setState({ loading: false });
            }

            if( nextProps.onboard.STATUS.CODE === "200" &&
                nextProps.onboard.STATUS.MESSAGE === "Successfully Send Invitation" ) {

                this.setState({
                    full_name: '',
                    email: '',
                    company: '',
                    departments: '[]',
                    loading: false
                });

                message.success( "Successfully Sent Invitation!" );
                this.props.get_candidate( 'all' );

            }
            
        }

    }

    handleOk(){

        let user = getCookie('dv_hrms_user').split(',');

        let temp = {
            user_id: user[1],
            user_email: user[2],
            full_name: this.state.full_name,
            email: this.state.email,
            company: this.state.company,
            department: this.state.department,
            departments: this.state.departments
        }

        if( this.state.full_name !== '' && this.state.email !== '' 
            && this.state.company !== '' && this.state.departments !== '[]' 
            && this.state.department !== '' ){
        
            this.props.invite_candidate( temp );    
            this.setState({ visible: false, loading: true });
        
        } else {
            message.error( 'All fields are mandatory!' );
        }

    }

    handleCancel(){
        this.setState({ 
            visible: false,
            full_name: '',
            email: '',
            company: '',
            departments: '[]'
        });
    }

    handleDepartment( value ){
        this.setState({ departments: JSON.stringify( value ) })
    }

    render() {

        const company_list = this.state.company_list.map( (item, key ) => <Option key={ item.company_id }>{ item.company_name }</Option> );
        const department_list = this.state.department_list.map( (item, key ) => <Option key={ item.department_id }>{ item.department_name }</Option> );
        const columns = [
            {
                title: 'Candidate Name',
                key: 'full_name',
                dataIndex: 'full_name',
                ...this.getColumnSearchProps( 'full_name' )
            },{
                title: 'Status',
                key: 'status',
                render: ( data ) => <span>
                    <Tag color={ (data.status === 'Active' ) ? 'green' : 'red' } key={data.user_id}>
                        { data.status }
                    </Tag>
                </span>
            },{
                title: 'Actions',
                key: 'actions',
                render: ( data ) => <span>
                    <Button size="small" type="default" 
                        disabled={ ( data.status === 'Active' ) ? false : true }
                        onClick={ ()=> this.props.checklist_request( data.user_id ) }
                        style={{ marginRight: '10px', fontSize: '11px' }}>Checklist Request</Button>
                    <Button size="small" type="primary" 
                        disabled={ ( data.status === 'Active' ) ? false : true }
                        onClick={ ()=> this.props.set_candidate_convert( data.user_id ) }
                        style={{ fontSize: '11px' }}>Convert To Employee Account</Button>
                </span>
            }
        ];

        return (
            <div className="reports_wrapper">
                <Spin spinning={this.state.loading}>
                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="usergroup-add" />
                            &nbsp; Candidate Onboarding 
                        </h2>
                    </Col>
                    <Col span={12}>

                        <Button
                            onClick={ ()=> this.setState({ visible: !this.state.visible }) }
                            className="fl_right" 
                            type="primary" 
                            icon="user-add">Invite New Candidate</Button>

                    </Col>
                </Row>
                
                <Divider />

                <Row gutter={16}>

                    <Col span={24}>

                        <Table columns={ columns } 
                            dataSource={ this.state.data }
                            defaultExpandedRowKeys={ ( this.props.match.params.id ) ? [0] : '' }
                            expandedRowRender={record => <div style={{ margin: 0 }} >
                            <Row>
                                <Col span={24}>
                                    <h2 className="mrg_b_20">Check List</h2>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    {
                                        ( record.checklist ) ? 
                                            record.checklist.map( (item, k ) => <div key={ k }>
                                                { Object.keys( item ).map( ( innerItem, i ) => <div key={ i } 
                                                    className="mrg_b_10"
                                                    style={{ 
                                                        clear: 'both',
                                                        overflow: 'hidden'
                                                    }}>
                                                    <h4>{ innerItem }</h4>
                                                    <div>
                                                        <ul className="checklist_view">
                                                            { item[ innerItem ].map( ( values, j ) =>
                                                                
                                                                <li key={ j }>
                                                                    <Checkbox
                                                                        disabled={ ( values.department_id === this.state.department_id || this.state.current_user_type === 'admin' ) ? false : true }
                                                                        onChange={ ( e ) => this.handleChecked( values.user_checklist_id, e ) }
                                                                        defaultChecked={ ( values.checked === '1' ) ? true : false }
                                                                        >{ values.check_list_name }</Checkbox>
                                                                </li>
                                                                
                                                            ) }
                                                        </ul>
                                                    </div>
                                                </div> ) }
                                            </div> ) : ''

                                    }

                                </Col>
                            </Row>

                        </div> } />

                    </Col>

                </Row>

                </Spin>

                <Modal
                    title="Invite Candidate"
                    maskClosable={ false }
                    visible={ this.state.visible }
                    onOk={ this.handleOk }
                    onCancel={ this.handleCancel } >

                    <div>
                        <Row className="mrg_b_10">
                            <Col span={ 24 }>
                                <label>Full Name</label>
                                <Input 
                                    value={ this.state.full_name }
                                    onChange={ ( e ) => this.setState({ full_name: e.target.value }) } />
                            </Col>
                        </Row>
                        <Row className="mrg_b_10">
                            <Col span={ 24 }>
                                <label>Email</label>
                                <Input 
                                    value={ this.state.email }
                                    onChange={ ( e ) => this.setState({ email: e.target.value }) } />
                            </Col>
                        </Row>
                        <Row className="mrg_b_10">
                            <Col span={ 24 }>
                                <label>Select Company</label>
                                <Select 
                                    value={ this.state.company }
                                    onChange={ ( value ) => this.setState({ company: value }) }
                                    style={{ width: '100%' }}>
                                    { company_list }
                                </Select>
                            </Col>
                        </Row>
                        <Row className="mrg_b_10">
                            <Col span={ 24 }>
                                <label>Select Department</label>
                                <Select 
                                    value={ this.state.department }
                                    onChange={ ( value ) => this.setState({ department: value }) }
                                    style={{ width: '100%' }}>
                                    { department_list }
                                </Select>
                            </Col>
                        </Row>
                        <Row className="mrg_b_10">
                            <Col span={ 24 }>
                                <label>Select Related Departments</label>
                                <Select 
                                    value={ JSON.parse( this.state.departments ) }
                                    mode="multiple"
                                    onChange={ this.handleDepartment }
                                    style={{ width: '100%' }}>
                                    { department_list }
                                </Select>
                            </Col>
                        </Row>
                    </div>

                </Modal>

            </div>
        )
    }
}

function mapStateToProps( state ) {
    return {
        onboard: state.onboard
    }
}

export default connect( mapStateToProps, { 
    invite_candidate, 
    get_company, 
    get_department, 
    get_candidate, 
    set_candidate_convert, 
    checklist_request,
    update_checklist_value } )( OnBoarding );



// WEBPACK FOOTER //
// ./src/pages/requests/onboarding/index.js